import axios from 'axios';
import qs from 'qs';

export class AxiosApiBase {
  private controller: AbortController;
  private axiosInstance;

  constructor() {
    this.controller = new AbortController();
    this.axiosInstance = axios.create({
      validateStatus: status => status >= 200 && status < 300,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });

    this.axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          this.controller.abort();
        }
        return Promise.reject(error || new Error('An unknown error occurred'));
      }
    );
  }

  setDefaultHeaders() {
    const token = localStorage.getItem('token');
    const clientId = localStorage.getItem('header.clientid');
    const companyId = localStorage.getItem('header.companyid');
    const employeeId = localStorage.getItem('header.employeeid');
    const hrDomain = localStorage.getItem('header.hrdomain');
    const payrollDb = localStorage.getItem('header.payrollDb');
    const hrDatabase = localStorage.getItem('header.hrDatabase');
    this.axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    this.axiosInstance.defaults.headers.common['x-clientid'] = clientId;
    this.axiosInstance.defaults.headers.common['x-companyid'] = companyId;
    this.axiosInstance.defaults.headers.common['x-hrdomain'] = hrDomain;
    this.axiosInstance.defaults.headers.common['x-employeeid'] = employeeId;
    this.axiosInstance.defaults.headers.common['x-payrolldatabase'] = payrollDb;
    this.axiosInstance.defaults.headers.common['x-hrdatabasename'] = hrDatabase;
  }

  public async get<T>(url: string): Promise<T> {
    this.setDefaultHeaders();
    const response = await this.axiosInstance.get(url);
    return response.data as T;
  }

  public async post<T>(url: string, data?: any, config?: any): Promise<T> {
    this.setDefaultHeaders();
    const response = await this.axiosInstance.post(url, data, config);
    return response.data as T;
  }

  public async put<T>(url: string, data?: any, config?: any): Promise<T> {
    this.setDefaultHeaders();
    const response = await this.axiosInstance.put(url, data, config);
    return response.data as T;
  }

  public async patch<T>(url: string, data?: any, config?: any): Promise<T> {
    this.setDefaultHeaders();
    const response = await this.axiosInstance.patch(url, data, config);
    return response.data as T;
  }

  public async download<T>(url: string): Promise<T> {
    this.setDefaultHeaders();
    const response = await this.axiosInstance.get(url, { responseType: 'blob' });
    return response.data as T;
  }
}
